module.exports = __webpack_public_path__ + "img/balognese.db7c225f.png";